module.exports = __webpack_public_path__ + "img/icon-chevron-down.121156f0.svg";